import React, { useMemo } from 'react'
import { SubmitHandler, useFormContext } from 'react-hook-form'
import FilterList from '@/components/content/FilterList'
import { chunk } from 'lodash-es'
import DateRangePickerInput from '@/components/date/DateRangePickerInput'
import Input from '@/components/content/Input'
import { DATE_FORMAT } from '@/utils/consts'
import dayjs from 'dayjs'
import { GetOutboundSummaryReq } from '@/services/outbound/outboundSearch/types'
import { SHIPPER_TYPES } from '@/services/shipper/apis'
import ShipperSelector from '@/components/system/ShipperSelector'

export const getInitForm = (parsedQs: Partial<GetOutboundSummaryReq> = {}): Partial<GetOutboundSummaryReq> => ({
  shipperNames: [],
  logisticsServiceTypes: parsedQs.logisticsServiceTypes
    ? Array.isArray(parsedQs.logisticsServiceTypes)
      ? parsedQs.logisticsServiceTypes
      : [parsedQs.logisticsServiceTypes]
    : SHIPPER_TYPES,
  cutDateFrom: parsedQs.cutDateFrom || dayjs().format(DATE_FORMAT.date),
  cutDateTo: parsedQs.cutDateTo || dayjs().format(DATE_FORMAT.date),
  cutOffNo: parsedQs.cutOffNo || undefined,
})

interface Props {
  isLoading: boolean
  onSubmit: SubmitHandler<GetOutboundSummaryReq>
  onFieldChange: (params: { fieldName: keyof GetOutboundSummaryReq; value: unknown; isSelectedAll?: boolean }) => void
  onReset: () => void
}

function OutboundSearchBatchForm({ isLoading, onSubmit, onFieldChange, onReset }: Props) {
  const { setValue, watch, handleSubmit } = useFormContext<GetOutboundSummaryReq>()
  const values = watch()

  const filterList = useMemo(
    () =>
      chunk(
        [
          {
            label: '화주명',
            required: true,
            value: (
              <ShipperSelector<GetOutboundSummaryReq> logisticsServiceTypesWidth={120} shipperNamesWidth={250} onFieldChange={onFieldChange} />
            ),
            validationValue: values.shipperNames && values.shipperNames.length > 0,
          },
          {
            label: '출고지시일자',
            required: true,
            value: (
              <DateRangePickerInput
                value={[values.cutDateFrom, values.cutDateTo]}
                maxDateRange={13}
                onChange={([start, end]) => {
                  setValue('cutDateFrom', start ? dayjs(start).format(DATE_FORMAT.date) : '')
                  setValue('cutDateTo', end ? dayjs(end).format(DATE_FORMAT.date) : '')
                }}
              />
            ),
          },
          {
            label: '차수명',
            value: <Input value={values.cutOffNo} placeholder="검색어 입력" onChange={(v) => setValue('cutOffNo', v)} />,
          },
        ],
        3,
      ),
    [values, onFieldChange],
  )

  return <FilterList isLoading={isLoading} list={filterList} onReset={onReset} onSearch={handleSubmit(onSubmit)} />
}

export default OutboundSearchBatchForm
